import { Checkbox } from '@radix-ui/react-checkbox';
import { ControllerRenderProps } from 'react-hook-form';
import { Icon } from '@/components/global/Icons';
import classNames from '@/lib/classNames';

const CustomCheckbox = (field: ControllerRenderProps) => {
    return (
        <Checkbox
            checked={field.value}
            onCheckedChange={() => {
                field.onChange(!field.value);
                field.onBlur();
            }}
            className={classNames(
                'peer mr-2 h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-white data-[state=checked]:text-white-foreground'
            )}
        >
            {!!field.value && <Icon id={'outline-check'} className="w-4 h-4 fill-primary" />}
        </Checkbox>
    );
};

export { CustomCheckbox };
